import { useTranslation } from "react-i18next";
import { APP_SIGNUP_PATH, buildAppUrl } from "@/lib/appUrl";

/**
 * The app URL for the locale currently on screen. `LocaleRoute` keeps
 * `i18n.language` in step with the URL prefix, so this is the language the
 * reader is actually reading — the one the app should open in.
 */
export function useAppUrl(pathOrUrl: string = APP_SIGNUP_PATH): string {
  const { i18n } = useTranslation();
  return buildAppUrl(pathOrUrl, i18n.language);
}
